
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.742 1.633l3.805 5.773V8L2.28 13.86h5.14c.324 0 .566-.021.727-.063a1.13 1.13 0 00.422-.195c.12-.084.227-.204.32-.36.1-.15.193-.362.282-.633.088-.27.172-.625.25-1.062h.914l-.227 3.812H.203v-.437l4.828-6.633L.5 1.266V.82h9.648v3.477h-.843c-.13-.495-.256-.899-.375-1.211a3.405 3.405 0 00-.36-.742 1.552 1.552 0 00-.375-.414 1.234 1.234 0 00-.437-.22 2.292 2.292 0 00-.664-.077H2.742z","fill":"currentColor"}})])
          )
        }
      }
    